import React from "react";
 
import SubjectTop from "../../top/subject";
 

const Subjects = () => {
  return (
    <div >
        <div  >
        <SubjectTop/>
 
        <div  className="flex flex-col lg:flex-row w-full lg:space-x-2 space-y-2 lg:space-y-0 mb-2 px-4  ">
            <div  className="w-full lg:w-1/4">
                <div  className="widget w-full p-4 rounded-lg bg-white shadow-md border   gray-800">
                    <div  className="flex flex-row items-center justify-between">
                        <div  className="flex flex-col">
                            <div  className="text-xs uppercase font-light text-gray-500">
                                Subjects
                            </div>
                            <div  className="text-xl font-bold">
                                6
                            </div>
                        </div>
                        <svg  className="stroke-current text-gray-500" fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewbox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2">
                            </path>
                            <circle cx="9" cy="7" r="4">
                            </circle>
                            <path d="M23 21v-2a4 4 0 0 0-3-3.87">
                            </path>
                            <path d="M16 3.13a4 4 0 0 1 0 7.75">
                            </path>
                        </svg>
                    </div>
                </div>
            </div>
            <div  className="w-full lg:w-1/4">
                <div  className="widget w-full p-4 rounded-lg bg-white shadow-md border   00">
                    <div  className="flex flex-row items-center justify-between">
                        <div  className="flex flex-col">
                            <div  className="text-xs uppercase font-light text-gray-500">
                                Total CGPA
                            </div>
                            <div  className="text-xl font-bold">
                                3.4
                            </div>
                        </div>
                        <svg  className="stroke-current text-gray-500" fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewbox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                            <polyline points="22 12 18 12 15 21 9 3 6 12 2 12">
                            </polyline>
                        </svg>
                    </div>
                </div>
            </div>
            <div  className="w-full lg:w-1/4">
                <div  className="widget w-full p-4 rounded-lg bg-white shadow-md border    er-gray-800">
                    <div  className="flex flex-row items-center justify-between">
                        <div  className="flex flex-col">
                            <div  className="text-xs uppercase font-light text-gray-500">
                                 classNamees
                            </div>
                            <div  className="text-xl font-bold">
                                40
                            </div>
                        </div>
                        <svg  className="stroke-current text-gray-500" fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewbox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6">
                            </path>
                            <polyline points="15 3 21 3 21 9">
                            </polyline>
                            <line x1="10" x2="21" y1="14" y2="3">
                            </line>
                        </svg>
                    </div>
                </div>
            </div>
            <div  className="w-full lg:w-1/4">
                <div  className="widget w-full p-4 rounded-lg bg-white shadow-md border    er-gray-800">
                    <div  className="flex flex-row items-center justify-between">
                        <div  className="flex flex-col">
                            <div  className="text-xs uppercase font-light text-gray-500">
                                 Time
                            </div>
                            <div  className="text-xl font-bold">
                                31h 2m
                            </div>
                        </div>
                        <svg  className="stroke-current text-gray-500" fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewbox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="10">
                            </circle>
                            <polyline points="12 6 12 12 16 14">
                            </polyline>
                        </svg>
                    </div>
                </div>
            </div>
        </div>

    <div  className="grid grid-cols-1 lg:grid-cols-2 p-4 gap-4">

     
      <div  className="relative flex flex-col min-w-0 mb-4 lg:mb-0 break-words bg-gray-50  y-800 w-full shadow-md rounded">
        <div  className="rounded-t mb-0 px-0 border">
          <div  className="flex flex-wrap items-center px-4 py-2">
            <div  className="relative w-full max-w-full flex-grow flex-1">
              <h3  className="font-semibold text-base text-gray-900  ray-50">Subject Info</h3>
            </div>
            <div  className="relative w-full max-w-full flex-grow flex-1 text-right">
              <button  className="bg-blue-500  y-100 text-white active:bg-blue-600  ray-800  :text-gray-700 text-xs font-bold uppercase px-3 py-1 rounded outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button">See all</button>
            </div>
          </div>
          <div  className="block w-full overflow-x-auto">
            <table  className="items-center w-full bg-transparent border-collapse">
              <thead>
                <tr>
                  <th  className="px-4 bg-gray-100  y-600 text-gray-500  ray-100 align-middle border border-solid border-gray-200  -gray-500 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">Course</th>
                  <th  className="px-4 bg-gray-100  y-600 text-gray-500  ray-100 align-middle border border-solid border-gray-200  -gray-500 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">Score</th>
                  <th  className="px-4 bg-gray-100  y-600 text-gray-500  ray-100 align-middle border border-solid border-gray-200  -gray-500 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left min-w-140-px"></th>
                </tr>
              </thead>
              <tbody>
                <tr  className="text-gray-700  ray-100">
                  <th  className="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left">English</th>
                  <td  className="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">2</td>
                  <td  className="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                    <div  className="flex items-center">
                      <span  className="mr-2">70%</span>
                      <div  className="relative w-full">
                        <div  className="overflow-hidden h-2 text-xs flex rounded bg-blue-200">
                          <div   className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-blue-600"></div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr  className="text-gray-700  ray-100">
                  <th  className="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left">English 121</th>
                  <td  className="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">3.3</td>
                  <td  className="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                    <div  className="flex items-center">
                      <span  className="mr-2">40%</span>
                      <div  className="relative w-full">
                        <div  className="overflow-hidden h-2 text-xs flex rounded bg-blue-200">
                          <div    className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-blue-500"></div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr  className="text-gray-700  ray-100">
                  <th  className="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left">Math</th>
                  <td  className="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">4</td>
                  <td  className="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                    <div  className="flex items-center">
                      <span  className="mr-2">45%</span>
                      <div  className="relative w-full">
                        <div  className="overflow-hidden h-2 text-xs flex rounded bg-pink-200">
                          <div    className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-pink-500"></div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr  className="text-gray-700  ray-100">
                  <th  className="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left">CSE 121</th>
                  <td  className="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">2.4</td>
                  <td  className="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                    <div  className="flex items-center">
                      <span  className="mr-2">60%</span>
                      <div  className="relative w-full">
                        <div  className="overflow-hidden h-2 text-xs flex rounded bg-red-200">
                          <div   className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-red-500"></div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr  className="text-gray-700  ray-100">
                  <th  className="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left">EEE</th>
                  <td  className="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">2.5</td>
                  <td  className="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                    <div  className="flex items-center">
                      <span  className="mr-2">30%</span>
                      <div  className="relative w-full">
                        <div  className="overflow-hidden h-2 text-xs flex rounded bg-blue-200">
                          <div  className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-blue-700"></div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
     
      <div  className="relative flex flex-col min-w-0 break-words bg-gray-50  y-800 w-full shadow-md rounded">
        <div  className="rounded-t mb-0 px-0 border">
          <div  className="flex flex-wrap items-center px-4 py-2">
            <div  className="relative w-full max-w-full flex-grow flex-1">
              <h3  className="font-semibold text-base text-gray-900  ray-50"> className Tests</h3>
            </div>
            <div  className="relative w-full max-w-full flex-grow flex-1 text-right">
              <button  className="bg-blue-500  y-100 text-white active:bg-blue-600  ray-800  :text-gray-700 text-xs font-bold uppercase px-3 py-1 rounded outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button">See all</button>
            </div>
          </div>
          <div  className="block w-full">
            <div  className="px-4 bg-gray-100  y-600 text-gray-500  ray-100 align-middle border border-solid border-gray-200  -gray-500 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
              Today
            </div>
            <ul  className="my-1">
              <li  className="flex px-4">
                <div  className="w-9 h-9 rounded-full flex-shrink-0 bg-indigo-500 my-2 mr-3">
                  <svg  className="w-9 h-9 fill-current text-indigo-50" viewBox="0 0 36 36"><path d="M18 10c-4.4 0-8 3.1-8 7s3.6 7 8 7h.6l5.4 2v-4.4c1.2-1.2 2-2.8 2-4.6 0-3.9-3.6-7-8-7zm4 10.8v2.3L18.9 22H18c-3.3 0-6-2.2-6-5s2.7-5 6-5 6 2.2 6 5c0 2.2-2 3.8-2 3.8z"></path></svg>
                </div>
                <div  className="flex-grow flex items-center border-b  -gray-400 text-sm text-gray-600  ray-100 py-2">
                  <div  className="flex-grow flex justify-between items-center">
                    <div  className="self-center">
                      <a  className="font-medium text-gray-800 hover:text-gray-900  ray-50  text-gray-100" href="#0" 
                      >Nick Mark</a> mentioned <a  className="font-medium text-gray-800  ray-50  text-gray-100" href="#0" 
                      >Sara Smith</a> in a new post
                    </div>
                    <div  className="flex-shrink-0 ml-2">
                      <a  className="flex items-center font-medium text-blue-500 hover:text-blue-600  lue-400  text-blue-500" href="#0" 
                      >
                        View<span><svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor"  className="transform transition-transform duration-500 ease-in-out"><path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"></path></svg></span>
                      </a>
                    </div>
                  </div>
                </div>
              </li>
              <li  className="flex px-4">
                <div  className="w-9 h-9 rounded-full flex-shrink-0 bg-red-500 my-2 mr-3">
                  <svg  className="w-9 h-9 fill-current text-red-50" viewBox="0 0 36 36"><path d="M25 24H11a1 1 0 01-1-1v-5h2v4h12v-4h2v5a1 1 0 01-1 1zM14 13h8v2h-8z"></path></svg>
                </div>
                <div  className="flex-grow flex items-center text-sm text-gray-600  ray-50 py-2">
                  <div  className="flex-grow flex justify-between items-center">
                    <div  className="self-center">
                      The post <a  className="font-medium text-gray-800  ray-50  text-gray-100" href="#0" 
                      >Post Name</a> was removed by <a  className="font-medium text-gray-800 hover:text-gray-900  ray-50  text-gray-100" href="#0" 
                      >Nick Mark</a>
                    </div>
                    <div  className="flex-shrink-0 ml-2">
                      <a  className="flex items-center font-medium text-blue-500 hover:text-blue-600  lue-400  text-blue-500" href="#0" 
                      >
                        View<span><svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor"  className="transform transition-transform duration-500 ease-in-out"><path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"></path></svg></span>
                      </a>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <div  className="px-4 bg-gray-100  y-600 text-gray-500  ray-100 align-middle border border-solid border-gray-200  -gray-500 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
              Yesterday
            </div>
            <ul  className="my-1">
              <li  className="flex px-4">
                <div  className="w-9 h-9 rounded-full flex-shrink-0 bg-green-500 my-2 mr-3">
                  <svg  className="w-9 h-9 fill-current text-light-blue-50" viewBox="0 0 36 36"><path d="M23 11v2.085c-2.841.401-4.41 2.462-5.8 4.315-1.449 1.932-2.7 3.6-5.2 3.6h-1v2h1c3.5 0 5.253-2.338 6.8-4.4 1.449-1.932 2.7-3.6 5.2-3.6h3l-4-4zM15.406 16.455c.066-.087.125-.162.194-.254.314-.419.656-.872 1.033-1.33C15.475 13.802 14.038 13 12 13h-1v2h1c1.471 0 2.505.586 3.406 1.455zM24 21c-1.471 0-2.505-.586-3.406-1.455-.066.087-.125.162-.194.254-.316.422-.656.873-1.028 1.328.959.878 2.108 1.573 3.628 1.788V25l4-4h-3z"></path></svg>
                </div>
                <div  className="flex-grow flex items-center text-sm text-gray-600  ray-50 py-2">
                  <div  className="flex-grow flex justify-between items-center">
                    <div  className="self-center">
                      <a  className="font-medium text-gray-800 hover:text-gray-900  ray-50  text-gray-100" href="#0" 
                      >240+</a> users have subscribed to <a  className="font-medium text-gray-800  ray-50  text-gray-100" href="#0" 
                      >Newsletter #1</a>
                    </div>
                    <div  className="flex-shrink-0 ml-2">
                      <a  className="flex items-center font-medium text-blue-500 hover:text-blue-600  lue-400  text-blue-500" href="#0"  >
                        View<span><svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor"  className="transform transition-transform duration-500 ease-in-out"><path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"></path></svg></span>
                      </a>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    
    </div>
 
      </div>
    </div>
    
  
    
 
  
  );
};

export default Subjects;
